"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Box = exports.boxBase = exports.box = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const should_forward_prop_1 = __importDefault(require("@styled-system/should-forward-prop"));
const styled_system_1 = require("../utils/styled-system");
/**
 * @deprecated
 */
const box = (props) => ({
    backgroundColor: props.backgroundColor,
    boxSizing: props.boxSizing,
    cursor: props.cursor,
    display: 'flex',
    flexDirection: 'column',
    userSelect: props.userSelect,
    whiteSpace: props.whiteSpace,
    ...(0, exports.boxBase)(props),
});
exports.box = box;
const boxBase = (props) => (0, styled_system_1.mergeStyles)([
    (0, styled_system_1.background)(props),
    (0, styled_system_1.border)(props),
    (0, styled_system_1.borderRadius)(props),
    (0, styled_system_1.boxShadow)(props),
    (0, styled_system_1.color)(props),
    (0, styled_system_1.flexbox)(props),
    (0, styled_system_1.grid)(props),
    (0, styled_system_1.layout)(props),
    (0, styled_system_1.opacity)(props),
    (0, styled_system_1.overflow)(props),
    (0, styled_system_1.position)(props),
    (0, styled_system_1.space)(props),
    (0, styled_system_1.typography)(props),
]);
exports.boxBase = boxBase;
/**
 * @deprecated use <Div /> instead
 */
exports.Box = (0, styled_1.default)('div', {
    shouldForwardProp: should_forward_prop_1.default,
})(exports.box);
